// extracted by mini-css-extract-plugin
export default {"result":"result_result__19tsA"};